import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m38.897 31.115 2.546 2.91A3 3 0 0 1 39.185 39H8a3 3 0 0 1-2.258-4.975l2.529-2.89a5 5 0 0 0 1.233-3.48l-.397-10.618c-.006-.168-.01-.337-.01-.505C9.098 9.058 15.158 3 22.63 3h1.726c.134 0 .269.002.403.006 7.522.223 13.44 6.501 13.218 14.024l-.315 10.644a5 5 0 0 0 1.235 3.44ZM18.096 41.408a1 1 0 1 1 1.831-.803 4 4 0 0 0 7.326.012 1 1 0 1 1 1.828.81 6 6 0 0 1-10.985-.019ZM12.475 29h22.243c1.333 0 1.333 2 0 2H12.475c-1.333 0-1.333-2 0-2Z",
    fill: "currentColor"
  }));
};

var SvgNotificationOn = styled(SvgComponent).withConfig({
  displayName: "NotificationOn__SvgNotificationOn",
  componentId: "sc-1ef1cc-0"
})(["", " ", ""], size, color);
export default SvgNotificationOn;